import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { buildFarmsLink, type FarmsLinkTarget } from 'pages/FarmsPage/hooks/farmsLinkTarget';

/** Opens another Farms view (tab, lens, tree node) keeping the rest of the URL. Pushes a history entry, so browser back returns to the previous view. */
const useFarmsLinkNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (target: FarmsLinkTarget) => {
      navigate(buildFarmsLink(location.pathname, location.search, target));
    },
    [navigate, location.pathname, location.search]
  );
};

export default useFarmsLinkNavigate;
